import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatterySavingsReportAvailabilityDto } from "../dto/battery-savings-report.dto"
import { batterySavingsReportService } from "../services/battery-savings-report.service"

export function useBatterySavingsReport(
  proposalId: string,
): UseQueryResult<BatterySavingsReportAvailabilityDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.savingsReport(proposalId),
    queryFn: () => batterySavingsReportService.availability(proposalId),
    staleTime: 0,
    retry: false,
    refetchInterval: (availability) =>
      availability &&
      !availability.ready &&
      [`pending`, `running`].includes(availability.reason)
        ? 3_000
        : false,
  })
}

export function useDownloadBatterySavingsReport(
  proposalId: string,
): UseMutationResult<{ pdf: Blob; filename: string }, unknown, void> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => batterySavingsReportService.download(proposalId),
    onError: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.savingsReport(proposalId),
      })
    },
  })
}
